import { LoginForm } from "../pages/login/LoginV2";
import { Signup } from "../pages/signup";
import { MultiStepLoanApplication } from "features/loanApplications/MultiStepForm";
import SalesHubDashboard from "features/salesHubDashboard/SalesHubDashboard";
import { Dashboard } from "../pages/dashboard";
import { LeadListPage } from "../pages/dashboard/LeadsPage";
import { LeadListPageV2 } from "../pages/dashboard/LeadsPageV2";
import { LeadDetailsPage } from "../pages/dashboard/LeadDetailsPage";
import { CreateLeadPage } from "../pages/dashboard/CreateLead";
import CreateApplicationPage from "pages/dashboard/CreateApplicationPage";
import { ApplicationDetailsPage } from "pages/dashboard/ApplicationDetailsPage";
import { ApplicationsPage } from "pages/dashboard/ApplicationsPage";
import { UploadDocumentPage } from "pages/dashboard/UploadDocumentPage";
import { UserLoginHistoryPage } from "pages/dashboard/UserLoginHistoryPage";
import { TaskListPage } from "../pages/dashboard/TaskListPage";
import { CreateTaskPage } from "../features/tasks/components/CreateTaskPage";
import { TaskDetailsPage } from "../pages/dashboard/TaskDetailsPage";
import { SettingsPage } from "../pages/dashboard/SettingsPage";
import { ResidenceVerificationPage } from "../pages/dashboard/ResidenceVerificationPage";
import { ResidenceVerificationViewPage } from "../pages/dashboard/ResidenceVerificationViewPage";
import { GroupsListPage } from "../pages/dashboard/GroupsListPage";
import { GroupDetailsPage } from "../pages/dashboard/GroupDetailsPage";
import { CreateGroupPage } from "../pages/dashboard/CreateGroupPage";
import { AddMemberPage } from "../pages/dashboard/AddMemberPage";
import { FeatureFlagRedirect } from "../v2/router/FeatureFlagRedirect";
import React from "react";

/**
 * Helper: wraps a v1 element with FeatureFlagRedirect so that when the
 * corresponding feature flag is enabled, the user is redirected to the v2 route.
 */
function withFlag(featureName, v2Path, V1Element) {
  return () => (
    <FeatureFlagRedirect featureName={featureName} v2Path={v2Path}>
      {React.createElement(V1Element)}
    </FeatureFlagRedirect>
  );
}

export const routesConfig = [
  {
    path: "/",
    element: LoginForm,
    exact: true,
    protected: false,
  },
  {
    path: "/login",
    element: LoginForm,
    exact: true,
    protected: false,
  },
  {
    path: "/signup",
    element: Signup,
    exact: true,
    protected: false,
  },
  {
    path: "/settings",
    element: withFlag("settings", "/v2/settings", SettingsPage),
    exact: true,
    protected: true
  },
  {
    path: "/dashboard",
    element: Dashboard,
    exact: true,
    protected: true,
    children: [
      {
        path: "",
        element: withFlag("dashboard", "/v2/", SalesHubDashboard),
        exact: true,
        protected: true,
      },
      {
        path: "application/:leadId",
        element: withFlag("applications", "/v2/applications/new", CreateApplicationPage),
        exact: true,
        protected: true,
      },
      {
        path: "application/details/:applicationId",
        element: withFlag("applications", "/v2/applications", ApplicationDetailsPage),
        exact: true,
        protected: true,
      },
      {
        path: "application/uploadDocument/:applicationId",
        element: withFlag("applications", "/v2/applications", UploadDocumentPage),
        exact: true,
        protected: true,
      },
      {
        path: "applications",
        element: withFlag("applications", "/v2/applications", ApplicationsPage),
        exact: true,
        protected: true,
      },
      {
        path: "leads-list",
        element: withFlag("leads", "/v2/leads", LeadListPage),
        exact: true,
        protected: false,
      },
      {
        path: "leads-list/v2",
        element: withFlag("leads", "/v2/leads", LeadListPageV2),
        exact: true,
        protected: false,
      },
      {
        path: "lead-details/:id",
        element: withFlag("leads", "/v2/leads", LeadDetailsPage),
        exact: true,
        protected: true,
      },
      {
        path: "leads/create-lead",
        element: withFlag("leads", "/v2/leads/create", CreateLeadPage),
        exact: true,
        protected: true,
      },
      {
        path: "loan/create-application",
        element: withFlag("applications", "/v2/applications/new", MultiStepLoanApplication),
        exact: true,
        protected: true,
      },
      {
        path: "login-history",
        element: withFlag("loginHistory", "/v2/login-history", UserLoginHistoryPage),
        exact: true,
        protected: true,
      },
      {
        path: "tasks",
        element: withFlag("tasks", "/v2/tasks", TaskListPage),
        exact: true,
        protected: true
      },
      {
        path: "lead-details/:resourceId/create-task",
        element: withFlag("tasks", "/v2/tasks/create", CreateTaskPage),
        exact: true,
        protected: true
      },
      {
        path: "application/details/:resourceId/create-task",
        element: withFlag("tasks", "/v2/tasks/create", CreateTaskPage),
        exact: true,
        protected: true
      },
      {
        path: "lead-details/:resourceId/tasks/:taskId",
        element: withFlag("tasks", "/v2/tasks", TaskDetailsPage),
        exact: true,
        protected: true
      },
      {
        path: "application/details/:resourceId/tasks/:taskId",
        element: withFlag("tasks", "/v2/tasks", TaskDetailsPage),
        exact: true,
        protected: true
      },
      {
        path: "residence-verification/:applicationId",
        element: withFlag("residenceVerification", "/v2/residence-verification", ResidenceVerificationPage),
        exact: true,
        protected: true
      },
      {
        path: "residence-verification/view/:applicationId",
        element: withFlag("residenceVerification", "/v2/residence-verification", ResidenceVerificationViewPage),
        exact: true,
        protected: true
      },
      {
        path: "groups",
        element: withFlag("groups", "/v2/groups", GroupsListPage),
        exact: true,
        protected: true
      },
      {
        path: "groups/create",
        element: withFlag("groups", "/v2/groups/create", CreateGroupPage),
        exact: true,
        protected: true
      },
      {
        path: "groups/:id",
        element: withFlag("groups", "/v2/groups", GroupDetailsPage),
        exact: true,
        protected: true
      },
      {
        path: "groups/:id/add-member",
        element: withFlag("groups", "/v2/groups", AddMemberPage),
        exact: true,
        protected: true
      }
    ],
  },
];
